<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center mb-60 mb-md-90">
                <h2 class="tit tit--lg">{{ title }}</h2>
            </div>

            <div class="my-n14 my-md-n20">
                <v-row>
                    <v-col cols="12" sm="6" v-for="program in programs" :key="program._id">
                        <hall-program-item :program="program" />
                    </v-col>
                </v-row>
            </div>

            <div class="v-pagination-wrap">
                <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-8 mb-16" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
            </div>
        </v-container>

        <v-fade-transition leave-absolute>
            <v-overlay v-show="loading" color="white" light>
                <v-progress-circular color="primary" indeterminate size="100" width="5" />
            </v-overlay>
        </v-fade-transition>
    </client-page>
</template>

<script>
import api from "@/api";
import { AUCTION_PROGRAM_HALLS } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import HallProgramItem from "@/components/client/auction/halls/hall-program-item.vue";

export default {
    components: {
        ClientPage,
        HallProgramItem,
    },
    props: {
        hall: { type: String, default: AUCTION_PROGRAM_HALLS.AUCTION_A.value },
    },
    data: () => ({
        programs: [],

        limit: 8,
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        title() {
            return Object.values(AUCTION_PROGRAM_HALLS).find(({ value }) => value == this.hall)?.text;
        },
        page() {
            return +this.$route.query.page || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        sort() {
            return JSON.stringify({ "duration.startsAt": 1, createdAt: 1 });
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
    },
    mounted() {
        this.init();
        this.search();
    },
    watch: {
        hall() {
            this.init();
            this.search();
        },
    },
    methods: {
        init() {
            this.works = [];
            this.totalCount = 0;

            if (!/^\/auction-halls/.test(this.$route.path)) {
                this.$router.replace({
                    path: `/auction-halls/${this.hall}`,
                    query: this.$route.query,
                });
            }
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { skip, limit, sort, hall } = this;
                const { summary, programs } = await api.v1.auction.programs.gets({
                    headers: { skip, limit, sort },
                    params: { hall, mode: "on-going" },
                });
                this.programs = programs;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
